import * as React from 'react';
import { IconProps } from './IconProps';
import { White } from '@traceair/tds';

const CalendarIcon = ({ color = White, size = '24' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.668 4H18.668V3C18.668 2.45 18.218 2 17.668 2C17.118 2 16.668 2.45 16.668 3V4H8.66797V3C8.66797 2.45 8.21797 2 7.66797 2C7.11797 2 6.66797 2.45 6.66797 3V4H5.66797C4.55797 4 3.67797 4.9 3.67797 6L3.66797 20C3.66797 21.1 4.55797 22 5.66797 22H19.668C20.768 22 21.668 21.1 21.668 20V6C21.668 4.9 20.768 4 19.668 4ZM19.668 19C19.668 19.55 19.218 20 18.668 20H6.66797C6.11797 20 5.66797 19.55 5.66797 19V9H19.668V19ZM7.66797 11H9.66797V13H7.66797V11ZM11.668 11H13.668V13H11.668V11ZM15.668 11H17.668V13H15.668V11Z"
      fill={color}
    />
  </svg>
);

export default CalendarIcon;
